import {
    Module,
    VuexModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';
import { 
    getReconciliationDashboard, 
    getReconciliationSummary, 
    getReconciliationRecords,
    getFraudAlertList,
    getAbuseReport,
    blockUser,
    suspiciousReport,
    fetchDashboardStats
} from '@/services/fraudManagement'

@Module({
    namespaced: true,
})

export default class FraudManagement extends VuexModule {
    // state 
    reconciliationDashboard = [];
    reconciliationSummary = [];
    reconciliationRecords = [];
    fraudAlertList = [];
    abuseReport = [];
    blockUserList = [];
    suspiciousReportList = [];
    
    @Action
    public async fetchDashboardStats() {
        try {
            const data = await fetchDashboardStats();
            return data;
        } catch (error) {
            throw error
        }
    }
    @Action
    public async fetchSuspiciousReportList(payload) {
        try {
            const data = await suspiciousReport(payload);
            this.context.commit('setSuspiciousReportList', data);
            return data;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async fetchBlockUserList() {
        try {
            const data = await blockUser();
            this.context.commit('setBlockUserList', data);
            return data;
        } catch (error) {
            throw error
        }
    }
    @Action
    public async fetchReconciliationDashboard() {
        try {
            const data = await getReconciliationDashboard();
            this.context.commit('setReconciliationDashboard', data);
            return data;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async fetchReconciliationSummary(payload) {
        try {
            const data = await getReconciliationSummary(payload.fromDate, payload.toDate);
            this.context.commit('setReconciliationSummary', data);
            return data;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async fetchReconciliationRecords() {
        try {
            const data = await getReconciliationRecords();
            this.context.commit('setReconciliationRecords', data);
            return data;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async fetchFraudAlertList(payload) {
        try {
            const data = await getFraudAlertList(payload);
            this.context.commit('setFraudAlertList', data);
            return data;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async fetchAbuseReport(payload) {
        try {
            const data = await getAbuseReport(payload);
            this.context.commit('setAbuseReport', data);
            return data;
        } catch (error) {
            throw error
        }
    }
    // mutations 
    @Mutation
    public setSuspiciousReportList(data: any) {
        this.suspiciousReportList = data;
    }
    @Mutation
    public setBlockUserList(data: any) {
        this.blockUserList = data;
    }
    @Mutation
    public setReconciliationDashboard(data: any) {
        this.reconciliationDashboard = data;
    }

    @Mutation
    public setReconciliationSummary(data: any) {
        this.reconciliationSummary = data;
    }

    @Mutation
    public setReconciliationRecords(data: any) {
        this.reconciliationRecords = data;
    }

    @Mutation
    public setFraudAlertList(data: any) {
        this.fraudAlertList = data;
    }

    @Mutation
    public setAbuseReport(data: any) {
        this.abuseReport = data;
    }
    // getters
    get GetReconciliationDashboard() {
        return this.reconciliationDashboard;
    }
    
    get GetReconciliationSummary() {
        return this.reconciliationSummary;
    }

    get GetReconciliationRecords() {
        return this.reconciliationRecords;
    }

    get GetFraudAlertList() {
        return this.fraudAlertList;
    }

    get GetAbuseReport() {
        return this.abuseReport;
    }
}

